import type React from "react";
import { DefaultV2 } from "~/components/common/layouts/DefaultV2";
import { ClientSettingLayout } from "~/components/common/layouts/settings/ClientSettingLayout";
import { CompanyVendorList } from "~/components/specifics/settings/company_vendors/CompanyVendorList";
import SettingStyles from "../SettingStyle.module.scss";

export const Page: React.FC = () => (
	<DefaultV2>
		<ClientSettingLayout>
			<h2 className={SettingStyles.SettingTitle}>提携中の施工会社一覧</h2>
			<p className={SettingStyles.TitleDescription}>
				並び替えの一番上にある施工会社が、案件追加時に初期選択されます。
			</p>
			<CompanyVendorList />
		</ClientSettingLayout>
	</DefaultV2>
);
